"use strict";
exports.__esModule = true;
exports.getCurrentSolanaPreloadData = exports.getSolanaPreloadData = exports.setSolanaPreloadData = void 0;
var rxjs_1 = require("rxjs");
var initialData = {
    version: "1",
    validatorsWithMeta: [],
    validators: []
};
var dataByCurrency = new Map([
    ["solana", initialData],
    ["solana_testnet", initialData],
    ["solana_devnet", initialData],
]);
var dataUpdatesByCurrency = new Map([
    ["solana", new rxjs_1.BehaviorSubject(initialData)],
    ["solana_testnet", new rxjs_1.BehaviorSubject(initialData)],
    ["solana_devnet", new rxjs_1.BehaviorSubject(initialData)],
]);
function setSolanaPreloadData(data, currency) {
    dataByCurrency.set(currency.id, data);
    var subject = dataUpdatesByCurrency.get(currency.id);
    if (subject === undefined) {
        throw new Error("unsupported currency ".concat(currency.id));
    }
    subject.next(data);
}
exports.setSolanaPreloadData = setSolanaPreloadData;
function getSolanaPreloadData(currency) {
    var subject = dataUpdatesByCurrency.get(currency.id);
    if (subject === undefined) {
        throw new Error("unsupported currency ".concat(currency.id));
    }
    return subject.asObservable();
}
exports.getSolanaPreloadData = getSolanaPreloadData;
function getCurrentSolanaPreloadData(currency) {
    var data = dataByCurrency.get(currency.id);
    if (data === undefined) {
        throw new Error("unsupported currency ".concat(currency.id));
    }
    return data;
}
exports.getCurrentSolanaPreloadData = getCurrentSolanaPreloadData;
//# sourceMappingURL=js-preload-data.js.map